import { getSidebarMenuPermissionFlagsFromCapabilities } from './capabilities'
import { useAuthRoles } from './use-auth-roles'
import { usePaymentsEnabled } from './use-payments-enabled'

export const useAuthPermissions = () => {
  const { user, isAdmin, isOwner, isManager, isUser, isPostCreator, isLoadingUser } = useAuthRoles()
  const paymentsEnabled = usePaymentsEnabled()

  const capabilityPermissions =
    isAdmin && Array.isArray(user?.capabilities) && user.capabilities.length > 0
      ? getSidebarMenuPermissionFlagsFromCapabilities(user.capabilities)
      : {
          canViewAdvertisements: isAdmin || isOwner || isManager,
          canEditAdvertisements: isAdmin || isOwner || isManager,
          canDeleteAdvertisements: isAdmin,
          canViewBookings: isAdmin || isOwner || isManager || isUser,
          canEditBookings: isAdmin || isOwner || isManager || isUser,
          canDeleteBookings: isAdmin || isUser,
          canViewProperties: isAdmin || isOwner,
          canEditProperties: isAdmin || isOwner,
          canDeleteProperties: isAdmin,
          canViewPosts: isAdmin || isUser || isPostCreator,
          canEditPosts: isAdmin || isUser || isPostCreator,
          canDeletePosts: isAdmin || isUser || isPostCreator,
          canViewUsers: isAdmin,
          canEditUsers: isAdmin,
          canDeleteUsers: isAdmin,
          canViewChat: isAdmin || isOwner || isManager || isUser || isPostCreator,
          canEditChat: isAdmin || isOwner || isManager || isUser || isPostCreator,
          canDeleteChat: isAdmin || isOwner || isManager || isUser || isPostCreator,
          canViewFiles: isOwner || isManager,
          canEditFiles: isOwner || isManager,
          canDeleteFiles: isOwner || isManager,
          canViewAnalytics: isAdmin || isOwner || isManager,
          canViewExports: isAdmin,
          canViewOrders: true,
          canViewCities: isAdmin,
          canEditCities: isAdmin,
          canDeleteCities: isAdmin
        }

  const permissions = {
    ...capabilityPermissions,
    canViewBookings:
      capabilityPermissions.canViewBookings || isAdmin || isOwner || isManager || isUser
  }

  return {
    ...permissions,

    // Manager assignment on properties is admin-only.
    canAssignPropertyManager: isAdmin,

    // Content approval (advertisements, posts) is admin-only.
    canApproveContent: isAdmin,

    // Admin-created bookings (register off-platform deals) are admin-only.
    canCreateBookings: isAdmin,

    canAskForSupport: isOwner || isManager,
    canViewSupportInbox: isAdmin,

    // Boost, orders & products (purchasing) are a Happa-only feature, toggled by NEXT_PUBLIC_PAYMENTS_ENABLED.
    canViewBoost: paymentsEnabled,
    canViewOrders: paymentsEnabled && capabilityPermissions.canViewOrders,

    // Expose loading state so consumers can wait before checking permissions.
    isLoadingPermissions: isLoadingUser
  }
}
